import { alpha, border, padding } from "@mui/system";

const styles = (theme) => ({
  containerModal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "16px",

    width: " 90%",
    maxWidth: "1000px",
    height: "700px",
    maxHeight: "90vh",
    overflow: "hidden",
    padding: "0 40px",
  },
  linearProgres: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  conatinerLoading: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  boxLine: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    background:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.white.light,
    borderRadius: "6px",
    p: 1,
  },
  boxTextField: { position: "relative", width: "100%" },
  BoxExitModal: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "50px",
    height: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  paperItens: {
    height: "100%",
    p: 2,
    gap: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    borderRadius: "16px",
  },
});

export default styles;
